(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('ProfileCreditController', ProfileCreditController);

        ProfileCreditController.$inject = ['$scope', '$state', 'entity', 'Principal', 'User', 'Profile', 'Education', 'Position', 'Picture', 'Dashboard', 'History'];

    function ProfileCreditController($scope, $state, entity, Principal, User, Profile, Education, Position, Picture, Dashboard, History) {
        var vm = this;
        vm.profile = entity;
        loadPicture(vm.profile);
        console.log(vm.profile);
        
        vm.creditsLastMonth;
        vm.credits;

        
        init();
        
        function init(){
            getCreditsHistory();
        }

        function getCreditsHistory() {
            History.myCredits({}, function (response) {
                if (response.credits){
                    vm.creditsLastMonth = response.credits[response.credits.length - 1];
                    vm.credits = response;
                    computeCharts(response.credits);
                }
            });
        }


        vm.datasetOverride = [
            {
              label: "Crédits",
              borderWidth: 1,
              type: 'bar'
            }
            
          ];
        function computeCharts(credits){
            vm.labels1 = credits.map(function (obj) {
                return obj.monthStr;
              });
            vm.data1 = [];
            vm.data1.push(credits.map(function (obj) {
                return obj.creditsCount;
              }));
            
          
        }
        
        function loadPicture(profile){
            if (profile.pictureContentType){
                Picture.getProfilePicture(profile.id).then(function (response) {
                    profile.picture=response;
                }, function (response) {
                });
            }
        }

    }
})();
